import type {
  ApiRequestMeta,
  UpdateUserProfileMutationResult,
  UpdateUserProfilePictureMutationResult,
  UserGeneralProfile,
} from "@jugl-web/rest-api";
import { createContext } from "react";
import { Subscription } from "rxjs";
import { RequestPayload, ResponsePayload } from "./types";
import { useUserProfileCache } from "./useUserProfileCache";

export interface UpdateUserProfileNamePayload {
  entityId: string;
  generalProfileId: string;
  userId: string;
  firstName: string;
  lastName: string;
  meta?: ApiRequestMeta;
}

export interface UpdateUserProfilePicturePayload {
  entityId: string;
  userId: string;
  file: File | null;
}

export interface UserProfileProviderContextValue {
  requestUserProfile: (payload: RequestPayload) => Promise<ResponsePayload>;
  getCachedUserProfile: ReturnType<
    typeof useUserProfileCache
  >["getCachedUserProfile"];
  watchProfileUpdates: (
    payload: { entityId: string; userId: string },
    callback: (profile: UserGeneralProfile) => void
  ) => Subscription;
  updateUserProfileName: (
    payload: UpdateUserProfileNamePayload
  ) => Promise<UpdateUserProfileMutationResult>;
  updateUserProfilePicture: (
    payload: UpdateUserProfilePicturePayload
  ) => Promise<UpdateUserProfilePictureMutationResult>;
}

export const UserProfileProviderContext =
  createContext<UserProfileProviderContextValue | null>(null);
